// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"282":"5c2c98a5efd6acdf","7955":"75394f83ce195e25"}[chunkId] + ".js";
};